module.exports = __webpack_public_path__ + "InternshipPlacement-307438cb.webp";